import {motion} from "framer-motion";
import {Col, Row} from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import React, {useRef} from "react";
import {FormattedMessage, useIntl} from "react-intl";

export default function VatiaCheckoutStep2(props)
{
    const intl = useIntl()

    let inputStyle = {width:"100%", height:45, marginBottom:10, padding:10, borderRadius: 5, border: "1px solid #CACACA", fontSize: 16, color: "#495057"};
    let inputStyle2 = {width:"100%", height:45, display: "inline-block", marginBottom:10, padding:10, borderRadius: 5, border: "1px solid #CACACA", fontSize: 16, color: "#495057"};
    let inputStyleInvalid = {width:"100%", height:45, display: "inline-block", marginBottom:10, padding:10, border: "2px solid #f44336", borderRadius: 5, fontSize: 16, color: "#495057"};

    let complete = props.email != null && props.email != "" &&
                    props.lastName != null && props.lastName != "" &&
                    props.line1 != null && props.line1 != "" &&
                    props.postalcode != null && props.postalcode != "" &&
                    props.city != null && props.city != "" &&
                    props.country != null && props.country != "" &&
                    props.phone != null && props.phone != "" &&
                    props.postalcode.length == 4 && props.phone.length == 12 &&
                    props.phoneIsValid

    return (<motion.div
        className="box"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
    >
        <Row style={{textAlign: "left", maxWidth:570, marginLeft: props.width>props.breakpoint ? "auto" : 6, marginRight: props.width>props.breakpoint ? 80 : 10,
            paddingLeft:0, paddingRight:0}}>
            {/*width: {width}*/}
            <form onSubmit={e => e.preventDefault()} style={{fontSize:16}}>
                <p style={{fontWeight:300, color:"grey", fontSize:15, marginBottom:10, marginTop:20}}>
                    <strong><FormattedMessage id={ 'abo.new.step2.contact.info' } defaultMessage={ 'Kontaktinformation'} /></strong>
                </p>
                <input style={inputStyle} autoComplete={"email"} defaultValue={props.email} placeholder={"Email"} type="text" name="email" onChange={props.handleEmail} required/><br/>
                <p style={{fontWeight:300, color:"grey", fontSize:15, marginBottom:10, marginTop:20}}>
                    <strong><FormattedMessage id={ 'abo.new.step2.delivery.address' } defaultMessage={ 'Lieferadresse'} /></strong>
                </p>
                <Row style={{margin:0}}>
                    <Col style={{paddingRight: props.width>props.breakpoint ? 6 : 0, paddingLeft:0}} xl={6} lg={6} md={6} sm={6} xs={12}>
                        <input style={inputStyle2} autoComplete={"given-name"} defaultValue={props.firstName} placeholder={intl.locale == "en" ? "Firstname" : "Vorname (optional)"} type="text" name="firstname" onChange={props.handleFirstname} required/>
                    </Col>
                    <Col style={{paddingLeft: props.width>props.breakpoint ? 5 : 0, paddingRight:0}} xl={6} lg={6} md={6} sm={6} xs={12}>
                        <input style={inputStyle2} autoComplete={"family-name"} defaultValue={props.lastName} placeholder={intl.locale == "en" ? "Lastname" : "Nachname"} type="text" name="lastname" onChange={props.handleLastname} required/>
                    </Col>
                </Row>
                <input style={inputStyle} autoComplete={"address-line1"} defaultValue={props.line1} placeholder={intl.locale == "en" ? "Street and house number" : "Strasse und Hausnummer"} type="text" name="address" onChange={props.handleAddress} required/><br/>
                <input style={inputStyle} autoComplete={"address-line2"} defaultValue={props.line2} placeholder={intl.locale == "en" ? "Additional address line (optional)" : "Zusätzliche Adressangaben (optional)"} type="text" name="address2" onChange={props.handleAddress2}/><br/>
                <Row style={{margin:0}}>
                    <Col style={{paddingRight: props.width>props.breakpoint ? 6 : 0, paddingLeft:0}} xl={6} lg={6} md={6} sm={6} xs={12}>
                        <input style={props.postalcode.length < 1 || props.postalcode.length == 4 ? inputStyle : inputStyleInvalid} autoComplete={"postal-code"} defaultValue={props.postalcode} placeholder={intl.locale == "en" ? "Zip" : "Plz"} type="text" name="plz" onChange={props.handlePlz} required/>
                    </Col>
                    <Col style={{paddingLeft: props.width>props.breakpoint ? 5 : 0, paddingRight:0}} xl={6} lg={6} md={6} sm={6} xs={12}>
                        <input style={inputStyle} autoComplete={"address-level2"} defaultValue={props.city} placeholder={intl.locale == "en" ? "City" : "Ort"} type="text" name="city" onChange={props.handleCity} required/><br/>
                    </Col>
                </Row>
                <input style={inputStyle} autoComplete={"country"} defaultValue={props.country} placeholder={intl.locale == "en" ? "Country" : "Land"} type="text" name="country" value={"Schweiz"} onChange={props.handleCountry} required disabled/><br/>
                <PhoneInput
                    country={"ch"}
                    enableSearch={true}
                    value={props.phone}
                    onChange={(value, country, e) => props.handlePhone(value, country)}
                    autoComplete={"tel"}
                    placeholder={"Telefon"}
                    name="phone"
                    required
                    inputStyle={{width:"100%", marginBottom: 0}}
                    isValid={(value, country) => {
                        return value.length == 2 || value.length == country.format.replaceAll(" ","").length-1
                    }}
                />
                <Row style={{textAlign:"right", marginLeft: "auto", marginRight:0}}>
                    {/*<button style={{backgroundColor:"#fff",border:0,borderRadius:4,color:"#e2e2e2",padding:6,marginTop:0, width: 100, height: 50, marginRight:10}}*/}
                    {/*        onClick={() => {props.handleBack()}}>*/}
                    {/*    Zurück*/}
                    {/*</button>*/}
                    <button style={{backgroundColor:complete ? "#f19800" : "#e2e2e2",
                        border:0,borderRadius:4,color:"#fff",padding:6,marginTop:30,
                        width: 150, height: 50, fontSize: 12, fontWeight: 600}}
                            onClick={() => {props.handleNext()}} disabled={!complete}>
                        <FormattedMessage id={ 'abo.new.button.continue.payment' } defaultMessage={ 'Weiter zur Zahlung'} />
                    </button>
                </Row>
            </form>
        </Row>
    </motion.div>)
}